<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="$l('table_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot :form="form" />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_status') || '状态'">
              <el-checkbox-group v-model="form.fabricStatusList" size="small">
                <el-checkbox label="Y" name="type">
                  {{ $l('form_label_available') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N" name="type">
                  {{ $l('form_label_notAvailable') || '无效' }}
                </el-checkbox>
                <el-checkbox label="Q" name="type">
                  {{ $l('form_label_new') || '新增' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_biz_user') || '业务员'">
              <dict-select
                v-model="form.fabricAgentCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_supplier') || '供应商'">
              <dict-select
                v-model="form.scmCode"
                url="/master/common/dict/scm"
                clearable
                filterable
                style="width: 100%"
                size="small"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_factoryFabricNumber') || '工厂面料编号'"
            >
              <el-input
                v-model="form.factoryNumber"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabricName') || '面料'">
              <dict-select
                v-model="form.fabricDescriptionList"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Fabric Description' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :options="{ label: 'label', value: 'label' }"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabricNumber') || '面料编号'">
              <el-input
                v-model="form.fabricNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabricSeriesNo') || '面料系列编号'">
              <el-input
                v-model="form.fabricSeriesNo"
                :placeholder="$l('tips_input_fabricSeriesNo') || '请输入面料系列编号'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_flowerType') || '花型'">
              <dict-select
                v-model="form.patternList"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Pattern' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :options="{ label: 'label', value: 'label' }"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_technology') || '工艺'">
              <dict-select
                v-model="form.techniqueList"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Technique' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :options="{ label: 'label', value: 'label' }"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_materialNotes') || '材料备注'">
              <dict-select
                v-model="form.constructionList"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Construction' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :options="{ label: 'label', value: 'label' }"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_function') || '功能'">
              <dict-select
                v-model="form.functionList"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Function' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :options="{ label: 'label', value: 'label' }"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_fabric_width') || '有效门幅'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widStart"
                  />
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widEnd"
                  />
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      v-model="form.widUnit"
                      url="/digitalCenter/common/dict/biz"
                      :body="{ dictType: 'widUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_fabricWeight') || '面料克重'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightStart"
                  />
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightEnd"
                  />
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      v-model="form.fabricWeightUnit"
                      url="/digitalCenter/common/dict/biz"
                      :body="{ dictType: 'fabricWeightUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    />
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = { searchKey: '', fabricStatusList: ['Y', 'Q'] }
export default {
  components: { },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
